import * as THREE from 'three';
import gsap from 'gsap';
import { hasParentWithName, invokeAfterDelay } from './Common';
import { SetCoinInsertLight } from './Light';
import { AnimationMouseEvents } from './Animations';
import {
    SetRandomObjet,
    step, SetStep,
    ShowTooltip, HideTooltip,
    ShowHomeUI,
    isVisibleBalloonUI, SetBombState, SetBombPosition,
    PressColor, SetVisibleSpray,
    SetLever, ControlLever,
    ChangePattern,
    slideCurveValues,
    SetSlideBlendShape, TweenSlideBlendShape, SetHandPower
} from './ScenarioManager';

import { RemoveAudio, SetAudio } from './Audio';

const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();
const mouseDownPos = new THREE.Vector2();
let canvasRect;
let intersects = [];
const targetObjects = [];
const targetObjectNames = [
    'start_coin', 's01_coin', 's01_hitbox',
    's01_button',
    // 's04_balloon', // !TEST
    's05_door', 's05_landing',
    's07_button_red', 's07_button_green', 's07_button_blue', 's07_lever', 's07_leverbody',
    's09_button_top', 's09_button_bot', 's09_button_enter',
    's10_bezier_curve_tanA', 's10_bezier_curve_tanB'
];

const targetObjectForStage = [
    ['start_coin', 's01_coin', 's01_hitbox'],
    ['s01_button'],
    [],
    [],
    [],
    [],
    ['s05_hitbox_center', 's05_hitbox_LB', 's05_hitbox_LT', 's05_hitbox_RB', 's05_hitbox_RT', 'floor'],
    [],
    [],
    [],
    ['s07_green_pump', 's07_red_pump', 's07_blue_pump',
        's07_green_cap', 's07_red_cap', 's07_blue_cap',
        's07_lever', 's07_leverbody'],
    [],
    [],
    ['s09_button_top', 's09_button_bot', 's09_button_enter'],
    [],
    [],
    ['s10_bezier_curve_tanA', 's10_bezier_curve_tanB', 's10_hitbox1', 's10_hitbox2'], //+ hands
    [],
    [],
    []
];

let currentObject;
let pointDownObject;

let initialPosition = new THREE.Vector3();
let isMouseDown = false;
let mousePressAnimationFrameID = null;

// const planeZ = new THREE.Plane(new THREE.Vector3(0, 0, 0.8), -0.3); // 코인이 움직일 평면 설정
const intersection = new THREE.Vector3();

let pressTime = 0;

//

export const SetStageRaycastList = (_scene, _step) => {
    targetObjects.length = 0;
    if (targetObjectForStage.length > _step) {
        targetObjectForStage[_step].forEach(name => {
            AddRaycastList(_scene, name);
        });
        if (_step === 16) AddRaycastListHandMeshObjects(_scene);
        // console.log('targetObjects', targetObjects);
    }
}

export const SetRaycastList = (_scene) => {
    targetObjectNames.forEach(name => {
        AddRaycastList(_scene, name);
    });
    console.log(targetObjects);
}

export const AddRaycastListHandMeshObjects = (_scene) => {
    const hand = _scene.getObjectByName('s10_hand');

    hand.traverse(child => {
        if (child.isMesh) {
            AddRaycastList(_scene, child.name);
        }
    })
}

const AddRaycastList = (_scene, _name) => {
    const target = _scene.getObjectByName(_name);

    if (!target) {
        console.warn(`⚠️ 대상 오브젝트(${_name})를 찾을 수 없습니다.`);
        return;
    }
    // 배열에 이미 존재하는지 확인
    if (targetObjects.includes(target)) {
        // console.log(`🔍 이미 추가된 오브젝트: ${_name}`);
    } else {
        targetObjects.push(target);
        // console.log(`✅ Raycast 대상 추가: ${_name}`);
    }
}

export const UpdateRaycaster = (camera) => {
    raycaster.setFromCamera(mouse, camera);
}

const GetIntersects = (event, scene, camera, canvasRef) => {
    // 캔버스 크기 기준으로 마우스 좌표 정규화 (-1 ~ 1 범위로 변환)
    canvasRect = canvasRef.current.getBoundingClientRect();
    mouse.x = ((event.clientX - canvasRect.left) / canvasRect.width) * 2 - 1;
    mouse.y = -((event.clientY - canvasRect.top) / canvasRect.height) * 2 + 1;

    // Raycaster를 사용하여 마우스 위치에서 광선 발사
    raycaster.setFromCamera(mouse, camera);

    // scene에 있는 모든 Mesh와 교차 검사
    //* 타겟 오브젝트만 레이 검출
    // intersects = raycaster.intersectObjects(targetObjects, true);
    //* 타겟 오브젝트가 있으면, 타겟만 없으면 씬 전체
    // intersects = raycaster.intersectObjects(targetObjects.length > 0 ? targetObjects : scene.children, true);
    //* 씬 전체
    intersects = raycaster.intersectObjects(scene.children, true);
    currentObject = getFirstIntersectedTargetObject();
}

export const onMouseDown = (event, scene, camera, canvasRef, Start) => {
    GetIntersects(event, scene, camera, canvasRef);
    //

    if (currentObject) {
        isMouseDown = true;
        mouseDownPos.x = mouse.x;
        mouseDownPos.y = mouse.y;
        // console.log("✅ 마우스 다운된 오브젝트:", currentObject.name, currentObject);
        // 원하는 이벤트 실행
        // initialPosition.copy(currentObject.position);
        initialPosition = new THREE.Vector3(-0.025, 0.45, .5);
        pointDownObject = currentObject;

        AnimationMouseEvents.mouseDown(pointDownObject);
        MouseEvents.mouseDown(pointDownObject, camera, Start);
        MouseEvents.mousePress(pointDownObject);
    }
    if (isMouseDown) canvasRef.current.style.cursor = 'grabbing';
}

export const onMouseMove = (event, scene, camera, canvasRef) => {
    GetIntersects(event, scene, camera, canvasRef);
    if (currentObject) {
        canvasRef.current.style.cursor = 'pointer';

        //todo hover event.
        AnimationMouseEvents.mouseHover(currentObject);
        MouseEvents.mouseHover(currentObject);
    }
    else {
        canvasRef.current.style.cursor = '';
    }
    if (isMouseDown) canvasRef.current.style.cursor = 'grabbing';

    if (!isMouseDown) return;
    event.preventDefault();

    //todo drag event.
    if (!pointDownObject) return;
    AnimationMouseEvents.mouseDrag(pointDownObject);
    MouseEvents.mouseDrag(pointDownObject);
    // console.log(initialPosition);
};

export const onMouseUp = (event, scene, camera, canvasRef, Start, Stop) => {
    // event.preventDefault();
    GetIntersects(event, scene, camera, canvasRef);

    //! TEST
    // console.log('- Intersects items -');
    // console.log('item Count :', intersects.length);
    // intersects.forEach(child => {
    //     console.log(child.object.name);
    // })

    if (currentObject) {
        // currentObject = intersects[0].object;
        canvasRef.current.style.cursor = 'pointer';

        if (currentObject === pointDownObject) {
            //todo click event.
            AnimationMouseEvents.mouseClick(currentObject);
            MouseEvents.mouseClick(currentObject);
        }
        else {
            //todo drag & drop event.
            AnimationMouseEvents.mouseDrop(currentObject, pointDownObject);
            MouseEvents.mouseDrop(currentObject, pointDownObject, Start);
        }
    }
    else {
        canvasRef.current.style.cursor = '';
    }

    if (isMouseDown) {
        isMouseDown = false;

        //* 마우스 프레스 이벤트 삭제
        if (mousePressAnimationFrameID) {
            cancelAnimationFrame(mousePressAnimationFrameID);
            mousePressAnimationFrameID = null;
        }
    }

    if (!pointDownObject) return;
    AnimationMouseEvents.mouseUp(pointDownObject);
    MouseEvents.mouseUp(pointDownObject, Stop);
    pointDownObject = null;
    pressTime = 0;
};

const MouseEvents = {
    mouseDown: (_downObject, camera, Start) => {
        if (_downObject.name === 'start_coin') {
            HideTooltip();
            Start();
            SetCoinInsertLight(true);
            targetObjects.splice(targetObjects.indexOf(_downObject), 1);
            gsap.killTweensOf(_downObject.rotation);
            _downObject.rotation.set(Math.PI / 2, 0, -Math.PI / 4);

            gsap.to(_downObject.scale, {
                x: 0.005,
                y: 0.005,
                z: 0.005,
                duration: 1,
                // ease: 'power2.inOut'
            })

            const updatePosition = () => {
                if (!isMouseDown) return; // 마우스를 떼면 업데이트 중지
                const adjustedZ = _downObject.position.z; // 마우스보다 약간 위로 오프셋
                const planeZ = new THREE.Plane(new THREE.Vector3(0, 0, 1), -adjustedZ);
                const offset = new THREE.Vector3(0, 0.015, 0); // 아래로 0.02 내림
                if (raycaster.ray.intersectPlane(planeZ, intersection)) {
                    _downObject.position.copy(intersection.clone().sub(offset));
                    // console.log('planeZ :', planeZ);
                    // console.log('coin pos :', _downObject.position);
                }
                requestAnimationFrame(updatePosition); // 다음 프레임에서 계속 실행
            };

            requestAnimationFrame(updatePosition); // 첫 실행
        }
        if (step === 1 && _downObject.name === 's01_button') {
            SetAudio('02_1_button_press.wav', true);
        }

        if (step === 10) {
            if (_downObject.name === 's07_red_pump' || _downObject.name === 's07_red_cap'
                || _downObject.name === 's07_green_pump' || _downObject.name === 's07_green_cap'
                || _downObject.name === 's07_blue_pump' || _downObject.name === 's07_blue_cap'
            ) {
                SetVisibleSpray(_downObject, true);
                SetAudio('09_1_pump_press.wav', true);
                SetAudio('10_spray.wav');
            }
            if (_downObject.name === 's07_lever') {
                //0~ 0.17
                SetAudio('11_1_pull_lever.wav');
            }
        }

        if (step === 13) {
            if (_downObject.name === 's09_button_top')
                SetAudio('13_next_button_press.wav', true);
            else if (_downObject.name === 's09_button_bot')
                SetAudio('13_next_button_press.wav', true);
            else if (_downObject.name === 's09_button_enter')
                SetAudio('14_select_button_press.wav', true);
        }

        if (step === 16) {
            if (_downObject.name === 's10_bezier_curve_tanA' || _downObject.name === 's10_hitbox2') {
                SetAudio('17_control_handle.wav');
            }
            else if (_downObject.name === 's10_bezier_curve_tanB' || _downObject.name === 's10_hitbox1') {
                SetAudio('17_control_handle.wav');
            }
            if (hasParentWithName(_downObject, 's10_hand')) {
                //* 누르자 마자 power 1
                pressTime = 30;
            }
        }

    },
    mousePress: (_pressObject) => {
        if (!isMouseDown) return;  // ✅ 마우스를 떼면 중지

        if (step === 10) {
            if (_pressObject.name === 's07_red_pump' || _pressObject.name === 's07_red_cap'
                || _pressObject.name === 's07_green_pump' || _pressObject.name === 's07_green_cap'
                || _pressObject.name === 's07_blue_pump' || _pressObject.name === 's07_blue_cap'
            ) {
                PressColor(_pressObject);
            }
        }

        if (step === 16) {
            if (hasParentWithName(_pressObject, 's10_hand')) {
                pressTime++;
                SetHandPower(pressTime);
            }
        }
        // ✅ 눌려진 오브젝트가 동일한 경우에만 아래 조건에 이벤트 추가
        if (currentObject === _pressObject) {
            // console.log("🔄 마우스 다운 중! 지속 이벤트 실행...", currentObject.name);
        }

        // 다음 프레임에서 다시 실행
        mousePressAnimationFrameID = requestAnimationFrame(() => {
            MouseEvents.mousePress(_pressObject);
        });
    },
    mouseHover: (_currentObject) => {

    },
    mouseDrag: (_dragedObject) => {
        if (_dragedObject.name === 'start_coin') {
            // 마우스 위치를 기준으로 Raycaster를 사용하여 3D 공간의 위치를 구함
            // const planeZ = new THREE.Plane(new THREE.Vector3(0, 0, 0.8), -_dragedObject.position.z);
            // if (raycaster.ray.intersectPlane(planeZ, intersection)) {
            //     _dragedObject.position.lerp(intersection, 0.1); // 부드러운 이동
            // }
        }
        if (step === 10) {
            if (_dragedObject.name === 's07_lever') {
                const delta = mouseDownPos.y - mouse.y;
                //0~ 0.17
                SetLever(delta);
            }
        }

        if (step === 16) {
            if (_dragedObject.name === 's10_bezier_curve_tanA' || _dragedObject.name === 's10_hitbox2') {
                if (slideCurveValues[0] === 1) {
                    const delta = mouseDownPos.x - mouse.x;
                    const value = THREE.MathUtils.clamp(delta * 10, 0, 1); // 0~1 사이로 조절
                    SetSlideBlendShape(_dragedObject, value);
                }
                else {
                    const delta = mouse.x - mouseDownPos.x;
                    const value = 1 - THREE.MathUtils.clamp(delta * 10, 0, 1); // 0~1 사이로 조절
                    SetSlideBlendShape(_dragedObject, value);
                }
            }
            else if (_dragedObject.name === 's10_bezier_curve_tanB' || _dragedObject.name === 's10_hitbox1') {
                if (slideCurveValues[1] === 1) {
                    const delta = Math.abs(mouseDownPos.x - mouse.x);
                    const value = THREE.MathUtils.clamp(delta * 10, 0, 1); // 0~1 사이로 조절
                    SetSlideBlendShape(_dragedObject, value);
                }
                else {
                    const delta = Math.abs(mouse.x - mouseDownPos.x);
                    const value = 1 - THREE.MathUtils.clamp(delta * 10, 0, 1); // 0~1 사이로 조절
                    SetSlideBlendShape(_dragedObject, value);
                }
            }
        }
    },
    mouseDrop: (_currentObject, _downObject, Start) => {
        if (_currentObject.name === 's01_hitbox' && _downObject.name === 'start_coin') {
            // SetRandomObjet();
            SetStep(1);
            Start();
            SetAudio('01_coin_insert.wav', true);
        }
        // if (step === 9) {
        //     if (_currentObject.name === 's07_leverbody' && _downObject.name === 's07_lever')
        //         SetStep(10);
        // }
    },
    mouseClick: (_clickedObject) => {
        // console.log(`🎬 ${_clickedObject.name} 클릭 이벤트 발생!`);

        //! TEST
        if (_clickedObject.name === 's04_balloon') {
            // SetVisibleBalloonEventUI(true);
            SetRandomObjet();
            SetStep(9);
            // SetVisibleCloud(true);
            return;
        }

        if (step === 1 && _clickedObject.name === 's01_button') SetStep(2);


        //* 폭격
        if (isVisibleBalloonUI) {
            if (_clickedObject.name === 's05_hitbox_center') {
                // console.log('🟢 폭격 성공 !');
                SetBombState(0);
            }
            //todo 폭격 히트박스
            else if (_clickedObject.name === 's05_hitbox_LB') {
                SetBombState(1);
            }
            else if (_clickedObject.name === 's05_hitbox_RB') {
                SetBombState(2);
            }
            else if (_clickedObject.name === 's05_hitbox_LT') {
                SetBombState(3);
            }
            else if (_clickedObject.name === 's05_hitbox_RT') {
                SetBombState(4);
            }
            else if (_clickedObject.name === 'floor') {
                // console.log('❎ 폭격 실패 !');
                //todo get mouse pos to world pos
                const rayHit = intersects.find(item => item.object.name === 'floor');
                if (rayHit) {
                    const hitPos = rayHit.point;
                    SetBombPosition(hitPos);
                }
                SetBombState(5);
            }
            SetStep(7);
        }

        if (step === 13) {
            if (_clickedObject.name === 's09_button_top') {
                ChangePattern('up');
            }
            else if (_clickedObject.name === 's09_button_bot') {
                ChangePattern('down');
            }
            else if (_clickedObject.name === 's09_button_enter') {
                SetStep(14);
            }
        }
    },
    mouseUp: (_downObject, Stop) => {
        // console.log('업 이벤트 발생 !');
        if (step === 0)
            if (_downObject.name === 'start_coin') {
                ShowTooltip();
                SetCoinInsertLight(false);
                gsap.killTweensOf(_downObject.position);
                gsap.to(_downObject.position, {
                    x: initialPosition.x,
                    y: initialPosition.y,
                    z: initialPosition.z,
                    ease: "power2.inOut",
                    duration: 1,
                    onComplete: () => {
                        Stop();
                        ShowHomeUI();
                        targetObjects.push(_downObject);
                    }
                });
                _downObject.rotation.set(-Math.PI / 2, Math.PI, 0);
                gsap.killTweensOf(_downObject.rotation);
                gsap.to(_downObject.rotation, {
                    z: '+=6.283',
                    duration: 2,
                    repeat: -1,
                    ease: 'none'
                });
                gsap.killTweensOf(_downObject.scale);
                gsap.to(_downObject.scale, {
                    x: 0.05,
                    y: 0.038,
                    z: 0.05,
                    duration: 1,
                    // ease: 'power2.inOut'
                })
            }
        if (_downObject.name === 's01_button') {
            SetAudio('02_2_button_release.wav', true);
        }
        if (step === 10) {
            if (_downObject.name === 's07_red_pump' || _downObject.name === 's07_red_cap'
                || _downObject.name === 's07_green_pump' || _downObject.name === 's07_green_cap'
                || _downObject.name === 's07_blue_pump' || _downObject.name === 's07_blue_cap'
            ) {
                SetVisibleSpray(_downObject, false);
                SetAudio('09_2_pump_release.wav', true);
                RemoveAudio('10_spray.wav');
            }

            if (_downObject.name === 's07_lever') {
                const delta = mouseDownPos.y - mouse.y;
                //0~ 0.17
                ControlLever(delta);
            }
        }
        if (step === 16) {
            if (_downObject.name === 's10_bezier_curve_tanA' || _downObject.name === 's10_hitbox2') {
                if (slideCurveValues[0] === 1) {
                    const delta = mouseDownPos.x - mouse.x;
                    const value = THREE.MathUtils.clamp(delta * 10, 0, 1); // 0~1 사이로 조절
                    TweenSlideBlendShape(_downObject, value);
                }
                else {
                    const delta = mouse.x - mouseDownPos.x;
                    const value = 1 - THREE.MathUtils.clamp(delta * 10, 0, 1); // 0~1 사이로 조절
                    TweenSlideBlendShape(_downObject, value);
                }
                RemoveAudio('17_control_handle.wav');
            }
            else if (_downObject.name === 's10_bezier_curve_tanB' || _downObject.name === 's10_hitbox1') {
                if (slideCurveValues[1] === 1) {
                    const delta = Math.abs(mouseDownPos.x - mouse.x);
                    const value = THREE.MathUtils.clamp(delta * 10, 0, 1); // 0~1 사이로 조절
                    TweenSlideBlendShape(_downObject, value);
                }
                else {
                    const delta = Math.abs(mouse.x - mouseDownPos.x);
                    const value = 1 - THREE.MathUtils.clamp(delta * 10, 0, 1); // 0~1 사이로 조절
                    TweenSlideBlendShape(_downObject, value);
                }
                RemoveAudio('17_control_handle.wav');
            }
            // console.log('preestime : ', pressTime);

            if (hasParentWithName(_downObject, 's10_hand')) {
                // console.log('슛 !');
                SetStep(17);
            }
        }
    }
}

const getFirstIntersectedTargetObject = () => {
    for (let i = 0; i < intersects.length; i++) {
        if (targetObjects.includes(intersects[i].object)) {
            return intersects[i].object; // ✅ 가장 먼저 레이가 닿은 오브젝트 반환
        }
    }
    return null; // ✅ `targetObjects`에 포함된 오브젝트가 없으면 `null` 반환
};